const urlParams = new URLSearchParams(window.location.search);
export const queryPostcode = urlParams.get('postcode');
export const queryConsumption = parseInt(urlParams.get('consumption'));
export const queryProducts = urlParams.get('products');
export const queryProductId = urlParams.get('product');
export const queryType = urlParams.get('type');
export const queryEco =  urlParams.get('eco') === 'true';
export const queryBonuswelten = urlParams.get('bonuswelten') === 'true';
export const queryBusiness = urlParams.get('business') === 'true';
export const queryDynamic = urlParams.get('isDynamicProduct') === 'true';
